export default __webpack_public_path__ + "b77863a375260a05dd13f86a1cee598f.woff";